export enum OrderAttachmentFileType {
  BillOfLading = "BillOfLading",
}
